export default {
  serverURI: 'https://api.safered.co/api',
  fixedLayout: false,
  hideLogoOnMobile: false
}
